// @flow

import React, {type Node as ReactNode} from "react";
import {Container} from "@material-ui/core";

export const ProfilePage = (): ReactNode => {
  return <Container>Hello World!</Container>;
};
